export default{
	getUrl() {
		if(process.env.buildType == "18hd"){
			return "http://static.iadhdb.com/"
		}else{
			return "http://static.qianmaiapp.com/"
		}
	}
}


// WEBPACK FOOTER //
// ./src/api/config.js